import { c as _c } from "react/compiler-runtime";
import { postHostedIdentifySessionKbaMutation } from '@onefootprint/fetch-hosted/queries';
import { useMutation } from '@tanstack/react-query';
import noop from 'lodash/noop';
import { useTranslation } from 'react-i18next';
import { useL10nContext } from '@/idv/components/l10n-provider';
import { checkIsPhoneValid } from '@/idv/utils';
import getHeader from '../../../utils/get-header';
import PhonePageStructure from '../../phone-page-structure';
import type { LoginChallengeProps } from '../login-challenge';
type PhoneKbaChallengeProps = {
  requirement: LoginChallengeProps['requirement'];
  context: Omit<LoginChallengeProps['context'], 'onPrev'>;
  onPrev: () => void;
  onSuccess: () => void;
};
const PhoneKbaChallenge = t0 => {
  const $ = _c(47);
  const {
    requirement,
    context,
    onSuccess,
    onPrev
  } = t0;
  const {
    state: t1,
    onError,
    initArgs: t2
  } = context;
  const {
    phoneNumber
  } = t1;
  const {
    config,
    logoConfig
  } = t2;
  const {
    t
  } = useTranslation("identify");
  let t3;
  let t4;
  if ($[0] !== context.state.identifyToken) {
    const headers = {
      "X-Fp-Authorization": context.state.identifyToken
    };
    t4 = useMutation;
    t3 = postHostedIdentifySessionKbaMutation({
      headers
    });
    $[0] = context.state.identifyToken;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] !== onError) {
    t5 = err => {
      onError("phone-kba-challenge", err);
    };
    $[3] = onError;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onSuccess || $[6] !== t3 || $[7] !== t5) {
    t6 = {
      ...t3,
      onError: t5,
      onSuccess
    };
    $[5] = onSuccess;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const mutIdentifyKba = t4(t6);
  const l10n = useL10nContext();
  let t7;
  if ($[9] !== config?.isLive) {
    t7 = phone => checkIsPhoneValid(phone, config?.isLive === false);
    $[9] = config?.isLive;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const handlePhoneValidation = t7;
  let t8;
  if ($[11] !== mutIdentifyKba) {
    t8 = phoneFromForm => {
      mutIdentifyKba.mutate({
        body: {
          "id.phone_number": phoneFromForm
        }
      });
    };
    $[11] = mutIdentifyKba;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const handleSubmit = t8;
  let t9;
  if ($[13] !== logoConfig || $[14] !== onPrev) {
    t9 = getHeader(logoConfig, onPrev);
    $[13] = logoConfig;
    $[14] = onPrev;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const Header = t9;
  const t10 = phoneNumber?.value;
  const t11 = mutIdentifyKba.isPending;
  const t12 = mutIdentifyKba.isPending ? noop : handleSubmit;
  let t13;
  if ($[16] !== t) {
    t13 = t(_temp);
    $[16] = t;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const t14 = requirement.user?.scrubbedPhone || "";
  let t15;
  if ($[18] !== t || $[19] !== t14) {
    t15 = t(_temp2, {
      number: t14.slice(-4).replace(/\*/g, "\u2022")
    });
    $[18] = t;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t) {
    t16 = t(_temp3);
    $[21] = t;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t) {
    t17 = t(_temp4);
    $[23] = t;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t) {
    t18 = t(_temp5);
    $[25] = t;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t) {
    t19 = t(_temp6);
    $[27] = t;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t) {
    t20 = t(_temp7);
    $[29] = t;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t13 || $[32] !== t15 || $[33] !== t16 || $[34] !== t17 || $[35] !== t18 || $[36] !== t19 || $[37] !== t20) {
    t21 = {
      headerTitle: t13,
      headerSubtitle: t15,
      cta: t16,
      emailChangeCta: t17,
      phoneInvalid: t18,
      phoneLabel: t19,
      phoneRequired: t20
    };
    $[31] = t13;
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== Header || $[40] !== handlePhoneValidation || $[41] !== l10n || $[42] !== mutIdentifyKba.isPending || $[43] !== t10 || $[44] !== t12 || $[45] !== t21) {
    t22 = <PhonePageStructure defaultPhone={t10} Header={Header} isLoading={t11} l10n={l10n} onSubmit={t12} phoneValidator={handlePhoneValidation} texts={t21} />;
    $[39] = Header;
    $[40] = handlePhoneValidation;
    $[41] = l10n;
    $[42] = mutIdentifyKba.isPending;
    $[43] = t10;
    $[44] = t12;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  return t22;
};
export default PhoneKbaChallenge;
function _temp($) {
  return $["confirm-phone-number"];
}
function _temp2($_0) {
  return $_0["before-email-code-confirmation"];
}
function _temp3($_1) {
  return $_1.continue;
}
function _temp4($_2) {
  return $_2.change;
}
function _temp5($_3) {
  return $_3["phone-step"].form["input-invalid"];
}
function _temp6($_4) {
  return $_4["phone-number"];
}
function _temp7($_5) {
  return $_5["phone-step"].form["input-required"];
}